import React, { useEffect, useState } from 'react';
import { apiFetch } from './api';

const formatFinancialNumber = (value) => {
  const num = Number(value);
  if (value === null || value === undefined || value === '' || Number.isNaN(num)) return '-';
  return num.toLocaleString('en-IN', { maximumFractionDigits: 0, minimumFractionDigits: 0 });
};

// The quarterly Period/Revenue/OP/NP table bse used to show directly below
// the candlestick chart (from /api/financials/:symbol) — kept separate from
// the bar-chart panels in the side panel, which come from a different feed.
const FinancialsTable = ({ link, reloadKey = 0 }) => {
  const [financials, setFinancials] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!link) return;
    let cancelled = false;
    setLoading(true);
    apiFetch(`/api/financials/${encodeURIComponent(link)}`)
      .then((r) => (r.ok ? r.json() : []))
      .then((data) => { if (!cancelled) setFinancials(Array.isArray(data) ? data : []); })
      .catch(() => { if (!cancelled) setFinancials([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [link, reloadKey]);

  if (!link) return null;
  if (loading) return <div className="muted-line">Loading financials…</div>;
  if (financials.length === 0) return null;

  return (
    <table className="financials-table">
      <thead><tr><th>Period</th><th>Revenue</th><th>OP</th><th>NP</th></tr></thead>
      <tbody>
        {financials.map((row, i) => (
          <tr key={i}>
            <td className="fin-period">{row.period}</td>
            <td className="fin-num">{formatFinancialNumber(row.revenue)}</td>
            <td className="fin-num">{formatFinancialNumber(row.op_profit)}</td>
            <td className="fin-num">{formatFinancialNumber(row.net_profit)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default FinancialsTable;

